'use strict';

import animationsUtility from '../utility/animations.js'

const init = () => {
    const strongTags = document.querySelectorAll("h1 strong, h2 strong, h3 strong, h4 strong, h5 strong")
    animationsUtility.animateHeadings(strongTags)
}

export default {init}
